import { INavData } from '@coreui/angular';

export function getNavItems(userRoles: string[]): INavData[] {
  const navItems: INavData[] = [];

  if (userRoles.includes('STUDENT')) {
    navItems.push(
      {
        name: 'Calendar',
        url: '/my_calendar',
        iconComponent: { name: 'cil-calendar' }
      },
      {
        name: 'Students',
        url: '/student',
        iconComponent: { name: 'cil-User' },
        children: [
          {
            name: 'Leave Request',
            url: '/student/leaving-campus'
          },
          {
            name: 'Leave List',
            url: '/student/leave-list'
          },
          {
            name: 'Curfew Hours Violations',
            url: '/student/curfew-hours-violations'
          },
          {
            name: 'Parent Details',
            url: '/student/parent-details',
          }
        ]
      });
  } else if (userRoles.includes('SUPER ADMIN')) {
    navItems.push(
      {
        name: 'Dashboard',
        url: '/dashboard-stats',
        iconComponent: { name: 'cil-speedometer' }
      },
      {
        name: 'Directory Admin',
        url: '/staff_admin/directory',
        iconComponent: { name: 'cil-calendar' }
      },
      {
        name: 'Student Management',
        url: '/student_admin',
        iconComponent: { name: 'cil-User' },
        children: [
          {
            name: 'Students',
            url: '/student_admin/student'
          },
          {
            name: 'Batch',
            url: '/student_admin/batch'
          },
          {
            name: 'Parents Details',
            url: '/student_admin/parent'
          },
          {
            name: 'Bulk Upload Images',
            url: '/student_admin/bulk_images_upload'
          },
          {
            name: 'Bulk Upload Students',
            url: '/student_admin/bulk_student_upload'
          },
          {
            name: 'Bulk Update Students',
            url: '/student_admin/bulk_student_update'
          },
          {
            name: 'Bulk Upload Parents',
            url: '/student_admin/bulk_upload_parent'
          }
        ]
      },
      {
        name: 'Staff Management',
        url: '/staff_admin',
        iconComponent: { name: 'cil-User' },
        children: [
          {
            name: 'Users',
            url: '/staff_admin/user'
          },
          {
            name: 'Role',
            url: '/staff_admin/role'
          },
          {
            name: 'Designation',
            url: '/staff_admin/designation'
          },
          {
            name: 'Access',
            url: '/staff_admin/access'
          },
          {
            name: 'Organisation/Team',
            url: '/staff_admin/organisation'
          }
        ]
      },
      {
        name: 'Room Schedule',
        url: '/room_schedule',
        iconComponent: { name: 'cil-Room' },
        children: [
          {
            name: 'Course',
            url: '/room_schedule/course'
          },
          {
            name: 'Room/Location',
            url: '/room_schedule/room'
          },
          {
            name: 'Session',
            url: '/room_schedule/session'
          },
          {
            name: 'Term',
            url: '/room_schedule/term'
          },
          {
            name: 'Term-Course',
            url: '/room_schedule/term_course'
          },

          {
            name: 'Room Booking',
            url: '/room_schedule/room_booking'
          },
          {
            name: 'Exam Grade',
            url: '/room_schedule/exam_grade'
          },
          {
            name: 'Exam Mode',
            url: '/room_schedule/exam_mode'
          },
          {
            name: 'Exam Type',
            url: '/room_schedule/exam_type'
          },
          {
            name: 'Exam Session',
            url: '/room_schedule/exam_session'
          },
          {
            name: 'Grade Scale',
            url: '/room_schedule/grade_scale'
          },
        ]
      },
      {
        name: 'Exam Module',
        url: '/exam',
        iconComponent: { name: 'cil-notes' },
        children: [
          {
            name: 'Exam Scheduling',
            url: '/exam/scheduling'
          },
          {
            name: 'Automated Timetables',
            url: '/exam/timetable/list'
          },
          {
            name: 'Upload Grades',
            url: '/exam/upload-grades'
          }
        ]
      },
      {
        name: 'Events',
        url: '/events',
        iconComponent: { name: 'cil-calendar-check' }
      },
      {
        name: 'Calendar',
        url: '/my_calendar',
        iconComponent: { name: 'cil-calendar' }
      },
      {
        name: 'Student Movement',
        url: '/security',
        iconComponent: { name: 'cil-shield-alt' },
        children: [
          {
            name: 'Leave Status Table',
            url: '/security/status'
          },
          {
            name: 'Student Movement List',
            url: '/security/movement_list'
          },
          {
            name: 'Student Movement Report',
            url: '/security/movement_report'
          },
          {
            name: 'Bulk Upload Movement',
            url: '/security/bulk_movement_upload'
          }
        ]
      },
      {
        name: 'Student Leave & Curfew',
        url: '/warden',
        iconComponent: { name: 'cil-User' },
        children: [
          {
            name: 'Student Leave Approval',
            url: '/warden/approval-form'
          },
          {
            name: 'Leave List',
            url: '/warden/approval-list'
          },
          {
            name: 'Curfew Hours',
            url: '/warden/curfew-hours'
          },
          {
            name: 'Curfew Hours Violations',
            url: '/warden/curfew-hours-violations'
          },
          {
            name: 'Major Curfew Hours Violations',
            url: '/warden/major-curfew-violations'
          },
          {
            name: 'Pending Approval - MH',
            url: '/warden/approvalForm/men'
          },
          {
            name: 'Leave List - MH',
            url: '/warden/approvalList/men'
          },
          {
            name: 'Pending Approval - WMH',
            url: '/warden/approvalForm/women'
          },
          {
            name: 'Leave List - WMH',
            url: '/warden/approvalList/women'
          }
        ]
      },
      {
        name: 'Hostel Management',
        url: '/hostel',
        iconComponent: { name: 'cil-home' },
        children: [
          { name: 'Hostel Dashboard', url: '/hostel/dashboard' },
          { name: 'Room Allocation', url: '/hostel/allocation' },
          { name: 'Check In', url: '/hostel/check-in' },
          { name: 'Check Out', url: '/hostel/check-out' },
          { name: 'Hostels', url: '/hostel/administration/hostels' },
          { name: 'Blocks', url: '/hostel/administration/blocks' },
          { name: 'Floors', url: '/hostel/administration/floors' },
          { name: 'Rooms', url: '/hostel/administration/rooms' },
          { name: 'Beds', url: '/hostel/administration/beds' },
          { name: 'Bulk Upload - Infrastructure', url: '/hostel/administration/bulk-upload' },
          { name: 'Bulk Upload - Allocation', url: '/hostel/allocation/bulk-upload' },
          { name: 'Occupancy', url: '/hostel/occupancy' },
          { name: 'Vacated List', url: '/hostel/vacated' },
          { name: 'Reports', url: '/hostel/reports' }
        ]
      });
  } else {
    // navItems.push({
    //   name: 'Directory Admin',
    //   url: '/staff_admin/directory',
    //   iconComponent: { name: 'cil-calendar' }
    // });

    navItems.push(
      {
        name: 'Dashboard',
        url: '/dashboard-stats',
        iconComponent: { name: 'cil-speedometer' }
      }
    );
    if (!userRoles.includes('EXAM ADMIN')) {
      navItems.push(
        {
          name: 'Directory Admin',
          url: '/staff_admin/directory',
          iconComponent: { name: 'cil-calendar' }
        },
        {
          name: 'Calendar',
          url: '/my_calendar',
          iconComponent: { name: 'cil-calendar' }
        }
      );
    }
    if (userRoles.includes('STAFF ADMIN')) {
      navItems.push(
        {
          name: 'Staff Management',
          url: '/staff_admin',
          iconComponent: { name: 'cil-User' },
          children: [
            {
              name: 'Users',
              url: '/staff_admin/user'
            },
            {
              name: 'Role',
              url: '/staff_admin/role'
            },
            {
              name: 'Access',
              url: '/staff_admin/access'
            },
            {
              name: 'Designation',
              url: '/staff_admin/designation'
            },
            {
              name: 'Organisation/Team',
              url: '/staff_admin/organisation'
            }
          ]
        }
      )
    }
    if (userRoles.includes('STUDENT ADMIN')) {
      navItems.push(
        {
          name: 'Student Management',
          url: '/student_admin',
          iconComponent: { name: 'cil-User' },
          children: [
            {
              name: 'Students',
              url: '/student_admin/student'
            },
            {
              name: 'Batch',
              url: '/student_admin/batch'
            },
            {
              name: 'Parents Details',
              url: '/student_admin/parent'
            }
          ]
        });
    }
    if (userRoles.includes('CLASSROOM SUPPORT') || userRoles.includes('FRONT DESK ADMIN') || userRoles.includes('EXAM ADMIN')) {
      navItems.push(
        {
          name: 'Room Schedule',
          url: '/room_schedule',
          iconComponent: { name: 'cil-Room' },
          children: [
            {
              name: 'Course',
              url: '/room_schedule/course'
            },
            {
              name: 'Room/Location',
              url: '/room_schedule/room'
            },
            {
              name: 'Session',
              url: '/room_schedule/session'
            },
            {
              name: 'Term',
              url: '/room_schedule/term'
            },
            {
              name: 'Term-Course',
              url: '/room_schedule/term_course'
            },

            {
              name: 'Room Booking',
              url: '/room_schedule/room_booking'
            },
            {
              name: 'Exam Grade',
              url: '/room_schedule/exam_grade'
            },
            {
              name: 'Exam Mode',
              url: '/room_schedule/exam_mode'
            },
            {
              name: 'Exam Type',
              url: '/room_schedule/exam_type'
            },
            {
              name: 'Exam Session',
              url: '/room_schedule/exam_session'
            },
            {
              name: 'Grade Scale',
              url: '/room_schedule/grade_scale'
            },
          ]
        });
      if (!userRoles.includes('EXAM ADMIN')) {
        navItems.push(
          {
            name: 'Events',
            url: '/events',
            iconComponent: { name: 'cil-calendar-check' }
          }
        );
      }
    }
    if (userRoles.includes('EXAM ADMIN') || userRoles.includes('STAFF ADMIN') || userRoles.includes('CLASSROOM SUPPORT') || userRoles.includes('COURSE INSTRUCTOR') || userRoles.includes('FACULTY')) {
      navItems.push(
        {
          name: 'Exam Module',
          url: '/exam',
          iconComponent: { name: 'cil-notes' },
          children: [
            {
              name: 'Exam Scheduling',
              url: '/exam/scheduling'
            },
            {
              name: 'Automated Timetables',
              url: '/exam/timetable/list'
            },
            {
              name: 'Upload Grades',
              url: '/exam/upload-grades'
            }
          ]
        }
      );
    }
    if (userRoles.includes('SECURITY')) {
      navItems.push(
        {
          name: 'Student Movement',
          url: '/security',
          iconComponent: { name: 'cil-shield-alt' },
          children: [
            {
              name: 'Leave Status Table',
              url: '/security/status'
            },
            {
              name: 'Student Movement List',
              url: '/security/movement_list'
            },
            {
              name: 'Mark Movement',
              url: '/security/movement'
            },
            {
              name: 'Student Movement Report',
              url: '/security/movement_report'
            },
            {
              name: 'Bulk Upload Movement',
              url: '/security/bulk_movement_upload'
            }
          ]
        });
      if (!userRoles.includes('WARDEN') && !userRoles.includes('WARDEN - MEN') && !userRoles.includes('WARDEN - WOMEN')) {
        navItems.push(
          {
            name: 'Student Curfew',
            url: '/warden',
            iconComponent: { name: 'cil-User' },
            children: [
              {
                name: 'Curfew Hours Violations',
                url: '/warden/curfew-hours-violations'
              },
              {
                name: 'Major Curfew Hours Violations',
                url: '/warden/major-curfew-violations'
              },
            ]
          }
        );
      }
    }
    if (userRoles.includes('WARDEN - MEN')) {
      navItems.push(
        {
          name: 'Student Leave & Curfew',
          url: '/warden',
          iconComponent: { name: 'cil-User' },
          children: [
            {
              name: 'Leave Approval - MH',
              url: '/warden/approvalForm/men'
            },
            {
              name: 'Leave List - MH',
              url: '/warden/approvalList/men'
            },
            {
              name: 'Curfew Hours',
              url: '/warden/curfew-hours'
            },
            {
              name: 'Curfew Hours Violations',
              url: '/warden/curfew-hours-violations'
            },
            {
              name: 'Major Curfew Hours Violations',
              url: '/warden/major-curfew-violations'
            },
          ]
        }
      );
    }
    if (userRoles.includes('WARDEN - WOMEN')) {
      navItems.push(
        {
          name: 'Student Leave & Curfew',
          url: '/warden',
          iconComponent: { name: 'cil-User' },
          children: [
            {
              name: 'Leave Approval - WMH',
              url: '/warden/approvalForm/women'
            },
            {
              name: 'Leave List - WMH',
              url: '/warden/approvalList/women'
            },
            {
              name: 'Curfew Hours',
              url: '/warden/curfew-hours'
            },
            {
              name: 'Curfew Hours Violations',
              url: '/warden/curfew-hours-violations'
            },
            {
              name: 'Major Curfew Hours Violations',
              url: '/warden/major-curfew-violations'
            },
          ]
        }
      );
    }
    if (userRoles.includes('HOSTEL ADMIN')) {
      navItems.push(
        {
          name: 'Hostel Management',
          url: '/hostel',
          iconComponent: { name: 'cil-home' },
          children: [
            { name: 'Hostel Dashboard', url: '/hostel/dashboard' },
            { name: 'Room Allocation', url: '/hostel/allocation' },
            { name: 'Check In', url: '/hostel/check-in' },
            { name: 'Check Out', url: '/hostel/check-out' },
            { name: 'Hostels', url: '/hostel/administration/hostels' },
            { name: 'Blocks', url: '/hostel/administration/blocks' },
            { name: 'Floors', url: '/hostel/administration/floors' },
            { name: 'Rooms', url: '/hostel/administration/rooms' },
            { name: 'Beds', url: '/hostel/administration/beds' },
            { name: 'Bulk Upload - Infrastructure', url: '/hostel/administration/bulk-upload' },
            { name: 'Bulk Upload - Allocation', url: '/hostel/allocation/bulk-upload' },
            { name: 'Occupancy', url: '/hostel/occupancy' },
            { name: 'Vacated List', url: '/hostel/vacated' },
            { name: 'Reports', url: '/hostel/reports' }
          ]
        }
      );
    }
    if (userRoles.includes('HOSTEL WARDEN')) {
      navItems.push(
        {
          name: 'Hostel Management',
          url: '/hostel',
          iconComponent: { name: 'cil-home' },
          children: [
            { name: 'Hostel Dashboard', url: '/hostel/dashboard' },
            { name: 'Check In', url: '/hostel/check-in' },
            { name: 'Check Out', url: '/hostel/check-out' },
            { name: 'Occupancy', url: '/hostel/occupancy' }
          ]
        }
      );
    }
    if (userRoles.includes('HOSTEL SECURITY')) {
      navItems.push(
        {
          name: 'Hostel Management',
          url: '/hostel',
          iconComponent: { name: 'cil-home' },
          children: [
            { name: 'Room Allocation', url: '/hostel/allocation' },
            { name: 'Check In', url: '/hostel/check-in' },
            { name: 'Check Out', url: '/hostel/check-out' },
            { name: 'Reports', url: '/hostel/reports' }
          ]
        });
    }

  }
  return navItems;
}
